import React, { useEffect, useState, useRef } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import { toast } from 'react-toastify';
import { localeData } from 'moment';
import edit from "../../../assets/images/edit.png";
import trash from "../../../assets/images/trash.png";
import ConfModal from '../../../Components/common/ConfModal.js';
export const UldSettings = () => {

  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingd, setIsLoadingd] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [gridDetailData, setGridDetailData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalPos, setModalPos] = useState({});
  const [modalUldType, setModalUldType] = useState(false);
  const [modalContour, setModalContour] = useState(false);
  const [formData, setFormData] = useState({})
  const [UldTypeFormData, setUldTypeFormData] = useState([]);
  const [ContourFormData, setContourFormData] = useState([]);
  const [uldTypes, setUldTypes] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const gridRef = useRef(null);
  const contourGridRef = useRef(null);
  const [gridSelect, setGridSelect] = useState([]);
  const [modalConf, setModalConf] = useState(false);
  const [confData, setConfData] = useState({});

  const [selectedRowData, setSelectedRowData] = useState(null);


  useEffect(() => {
    if (isMounted.current) return;
    setIsLoading(true)
    setGridData({})
    // setUldTypeFormData({})
    fetchOwnerCode();
    // loadUldTypeGrid();
    isMounted.current = true;
  }, []);

  const addModal = (e, m) => {
    setModalPos({ sec: e, mode: m });
    if (m === 'Add') {
      setFormData({})
    }
    setShowModal(true);
  }
  const closeModal = () => {
    setModalPos({});
    setShowModal(false);
  }

  const modalSubmit = () => {
    let endpoint;
    let payload = formData;

    if (modalPos.sec === 'U') {
      endpoint = 'uld-type/save';
    } else if (modalPos.sec === 'C') {
      endpoint = 'contour/save';
      payload = { ...payload, rfs_uld_type_id: selectedRowData?.id }
    }
    CallApi({
      endPoint: endpoint,
      payload: payload,
      onSuccess: (data) => {
        if (data.data.response_code === 200) {
          setFormData({});
          // loadUldTypeGrid();
          if (modalPos.sec === 'U') {
            setTimeout(() => {
              window.$(gridRef.current).jqxGrid('updatebounddata');
            }, 1);
            if (selectedRowData) {
              setSelectedRowData(null)
            }
          } else if (modalPos.sec === 'C') {
            loadDetails(selectedRowData, 'D')
          }
          setShowModal(false)
        } else {
          toast.error(data.response_msg);
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }
  const submitUldType = () => {
    CallApi({
      endPoint: 'uld-type/save',
      payload: formData,
      onSuccess: (data) => {
        if (data.data.response_code === 200) {
          setModalUldType(false);
          setFormData({});
          // loadUldTypeGrid();
          setTimeout(() => {
            window.$(gridRef.current).jqxGrid('updatebounddata');
          }, 1);
          if (selectedRowData) {
            setSelectedRowData(null)
          }
        } else {
          toast.error(data.response_msg);
        }
      },
      onError: (msg) => toast.error(msg)
    });
  };
  const submitContour = () => {
    setIsLoadingd(false)
    CallApi({
      endPoint: 'contour/save',
      payload: {
        ...formData,
        contour_id: selectedRowData?.id,
      },
      onSuccess: (data) => {
        if (data.data.response_code === 200) {
          setModalContour(false);
          setFormData({});
          // setSelectedRowData(null);
          // loadUldTypeGrid();

          loadDetails(selectedRowData, 'D')
          // setTimeout(() => {
          //   // window.$(contourGridRef.current).jqxGrid('updatebounddata');
          //   window.$(gridRef.current).jqxGrid('updatebounddata');

          // }, 1);
        } else {
          toast.error(data.response_msg);
        }
      },
      onError: (msg) => toast.error(msg)
    });

  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'contour_activated') {
      console.log('asdsasad');

      setFormData({
        ...formData,
        [name]: Number(value)
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }

  };

  const fetchOwnerCode = async () => {
    try {
      CallApi({
        endPoint: 'uld-forms/get-type-code',
        onSuccess: (data) => {
          if (data.data.response_code === 200) {
            const innerData = data.data.response_data;
            const transformedData = innerData ? innerData.map(item => ({
              value: item.uld_typecode,
              label: item.uld_typecode
            })) : [];
            setUldTypes(transformedData);
          } else {
            toast.error(data.response_msg);
          }
        },
        onError: (msg) => toast.error(msg)
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  let checkUlds = [];
  let filterForCheck = false;
  useEffect(() => {

    if (gridRef.current) {

      // var token = "Bearer " + localStorage.RFS;
      jqxCookieCall()
      const source = {
        datatype: 'json',
        id: '1',
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'uld_type', type: 'string' },
          { name: 'org_id', type: 'string' },
          { name: 'contour_activated', type: 'string' },
          { name: 'length', type: 'string' },
          { name: 'width', type: 'string' },
          { name: 'height', type: 'string' },
          { name: 'type', type: 'string' },
          { name: 'created_at', type: 'string' },
          { name: 'created_by', type: 'string' },
          { name: 'updated_at', type: 'string' },
          { name: 'deleted_at', type: 'string' },
          { name: 'updated_by', type: 'string' },
          { name: 'contours', type: 'string' },
        ],
        url: `${process.env.REACT_APP_RFS_URL}uld-types`,
        // beforeSend: function (jqXHR) {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        pagesize: 20,
         filter: function (allfilters) {
          if (allfilters.length > 0) {
            setFilterApplied(true);
            filterForCheck = true;
          } else {
            setFilterApplied(false);
            filterForCheck = false;
          }
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          source.totalrecords = data.TotalRows;
          console.log('findRow==1', selectedRowData);
          if (selectedRowData) {
            setIsLoadingd(false)
            const findRow = data.Rows.find(f => f.id === selectedRowData.id);
            console.log('findRow==2', findRow);

            setIsLoadingd(true)
            setGridDetailData(findRow.contours)
          }
        },
        sort: function () {
          window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
        },
        root: "Rows",
        cache: false,
      };

      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        {
          text: 'Actions',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_delete" /></div>';
          },
          width: '10%', filterable: false,
        },
        { text: 'ULD Type', filtertype: 'input', datafield: 'uld_type', width: '30%' },
        {
          text: 'Contours',
          filtertype: 'input',
          datafield: 'contour_activated',
          width: '30%',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            if (cellValue == 0) {
              return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">No</div>`;
            } else {
              return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">Yes</div>`;
            }
          }
        },
        {
          text: 'Contours Amount', filtertype: 'input', datafield: 'contours', width: '30%',
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            return `<div class="jqx-grid-cell-left-align" style="margin-top: 13.5px;">${cellValue.length}</div>`;

          }
        }
      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        // selectionmode: 'checkbox',
        pageable: true,
        pageSize: 10,
        pagesizeoptions: ['20', '50', '100', '200'],
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
      };

      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(gridRef.current).on('click', '.row_delete', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        // const rowIndex = window.$(rowDiv).attr('row-id');
        const rowIndex = window.$(gridRef.current).jqxGrid('getrowboundindex', window.$(this).closest('[role="row"]').index());
        let rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        // rowData.type= 'Contour';
        confModalOpen(rowData.id, 'U')
      });
      window.$(gridRef.current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        setGridSelect(rowData);
        setFormData({
          uld_type: rowData.uld_type,
          contour_activated: rowData.contour_activated,
          length: rowData.length,
          width: rowData.width,
          height: rowData.height,
          type: rowData.type,
          id: rowData.id,
        })
        // setModalUldType(true);
        addModal('U', 'Edit')
      });
      window.$(gridRef.current).off('cellclick');
      window.$(gridRef.current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (event.args.columnindex > 0) {
          loadDetails(args)
        }
      });
    }
  }, [gridData]);

  const loadDetails = (dta, pos) => {
    CallApi({
      endPoint: 'uld-type/contours',
      payload: { id: dta.id },
      onSuccess: (data) => {
        const innerData = data.data.Rows;
        setModalContour(false);
        setFormData({});
        setSelectedRowData(dta)
        setGridDetailData(innerData)
        if (pos === 'D') {
          setTimeout(() => {
            window.$(gridRef.current).jqxGrid('updatebounddata');
          }, 1);
        }

      },
      onError: (msg) => toast.error(msg)
    });
  }

  useEffect(() => {

    if (contourGridRef.current) {
      const source = {
        datatype: 'json',
        id: 'id',
        localdata: gridDetailData,
        datafields: [
          { name: 'contour', type: 'string' },
          { name: 'contour_id', type: 'string' },
          { name: 'created_at', type: 'string' },
          { name: 'created_by', type: 'string' },
          { name: 'deleted_at', type: 'string' },
          { name: 'height', type: 'string' },
          { name: 'id', type: 'string' },
          { name: 'length_value', type: 'string' },
          { name: 'org_id', type: 'string' },
          { name: 'type', type: 'string' },
          { name: 'updated_at', type: 'string' },
          { name: 'updated_by', type: 'string' },
          { name: 'width', type: 'string' },
        ],
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      const columns = [
        {
          text: 'Actions',
          cellsrenderer: function () {
            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_delete" /></div>';
          },
          width: '10%', filterable: false,
        },
        { text: 'Contour', datafield: 'contour', width: '27%' },
        { text: 'Length (CM)', datafield: 'length_value', width: '12%' },
        { text: 'Width (CM)', datafield: 'width', width: '12%' },
        { text: 'Height (CM)', datafield: 'height', width: '12%' },
        { text: 'Pallete', datafield: 'type', width: '22%' },
      ];
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: false,
        // height: 800,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        pagesizeoptions: ['20', '100', '200', '500'],
        pageable: true,
        pageSize: 20,
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        // selectionmode: 'checkbox',
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        },
      };

      window.$(contourGridRef.current).jqxGrid(gridOptions);
      window.$(contourGridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
      window.$(contourGridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });
      window.$(contourGridRef.current).on('click', '.row_delete', function () {
        // const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(contourGridRef.current).jqxGrid('getrowboundindex', window.$(this).closest('[role="row"]').index());
        const rowData = window.$(contourGridRef.current).jqxGrid('getrowdata', rowIndex);
        // rowData.type= 'Contour';
        confModalOpen(rowData.id, 'C')
      });
      window.$(contourGridRef.current).on('click', '.row_edit', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        console.log('rowDiv', rowDiv);
        // const rowIndex = window.$(rowDiv).attr('row-id');
        const rowIndex = window.$(contourGridRef.current).jqxGrid('getrowboundindex', window.$(this).closest('[role="row"]').index());
        console.log('rowIndex', rowIndex);
        const rowData = window.$(contourGridRef.current).jqxGrid('getrowdata', rowIndex);
        console.log('rowData', rowData);

        setGridSelect(rowData);
        setFormData({
          // uld_type: rowData.uld_type,
          // contour_activated: rowData.contour_activated,
          id: rowData.id,
          contour: rowData.contour,
          length: rowData.length_value,
          width: rowData.width,
          height: rowData.height,
          type: rowData.type,
          id: rowData.id,
        })
        // setModalUldType(true);
        addModal('C', 'Edit')
      });
    }
  }, [gridDetailData, selectedRowData]);

  const confModalOpen = (ID, pos) => {
    setConfData({
      header: `Remove ${pos === 'C' ? 'Contour' : 'ULD Type'}`,
      subHeader: `Are you sure you want to remove this  ${pos === 'C' ? 'Contour' : 'ULD Type'}`,
      modalConf: { tabChangeConf },
      closeModal: { confModalClose },
      primaryBtn: 'Yes',
      secondaryBtn: 'No',
      id: ID,
      sec: pos
    })
    setModalConf(true);
  }
  const confModalClose = () => {
    setModalConf(false);
  }

  const tabChangeConf = () => {
    let endpoint;
    if (confData.sec === 'U') {
      endpoint = 'uld-type/delete-restore';
    } else if (confData.sec === 'C') {
      endpoint = 'contour/delete-restore';
    }
    CallApi({
      endPoint: endpoint,
      payload: { id: confData.id },
      onSuccess: (data) => {
        if (data.data.response_code === 200) {
          if (confData.sec === 'U') {
            setTimeout(() => {
              window.$(gridRef.current).jqxGrid('updatebounddata');
            }, 1);
            if (selectedRowData) {
              setSelectedRowData(null)
            }
          } else if (confData.sec === 'C') {
            loadDetails(selectedRowData, 'D')
          }
        } else {
          toast.error(data.response_msg);
        }
      },
      onError: (msg) => toast.error(msg)
    });
    setModalConf(false);
  }


  return (
    <>
      {console.log('formData', formData)}
      {modalConf &&
        <ConfModal
          header={confData.header}
          subHeader={confData.subHeader}
          modalConf={tabChangeConf}
          closeModal={confModalClose}
          primaryBtn={confData.primaryBtn}
          secondaryBtn={confData.secondaryBtn}
        />
      }
      <div className='col-9 col-xxl-9 stting_right'>
        <div className='settingbg_right'>
          <Row>
            <Col sm={6}>
              <h4>ULD Type Settings</h4>
              <p>Add ULD Type</p>
              <div>
                <Button variant="primary createplan" onClick={() => addModal('U', 'Add')}>
                  <FontAwesomeIcon icon={faPlus} /> Add ULD Type
                </Button>
              </div>
              {isLoading && <div ref={gridRef} className='staion_grid' ></div>}
              {/* <div ref={gridRef} className="staion_grid" /> */}
            </Col>
            <Col sm={6}>
              {selectedRowData && (
                <>
                  <h2>{selectedRowData.uld_type}</h2>
                  <p>Contour Activated: {selectedRowData?.contour_activated == 0 ? "No" : "Yes"}</p>
                  {selectedRowData?.contour_activated == 0 &&
                    <>
                      <p>Length in CM: {selectedRowData?.length}</p>
                      <p>Width in CM: {selectedRowData?.width}</p>
                      <p>Height in CM: {selectedRowData?.height}</p>
                      <p>Type: {selectedRowData?.type}</p>
                    </>
                  }
                  <Button variant="primary createplan" onClick={() => addModal('C', 'Add')}>
                    <FontAwesomeIcon icon={faPlus} /> Add Contour
                  </Button>
                  {/* <div ref={contourGridRef} className="staion_grid" /> */}
                  <div ref={contourGridRef} className='staion_grid' ></div>
                </>
              )}
            </Col>
          </Row>
        </div>
      </div>
      <Modal show={showModal} centered onHide={closeModal} className='addfrom' >
        <Modal.Header closeButton>
          <Modal.Title>{modalPos.mode} {modalPos.sec === 'U' ? 'ULD Type' : 'Contour'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalPos.sec === 'U' &&
            <>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>ULD Type</Form.Label>
                <Select
                  options={uldTypes}
                  placeholder="ULD Type"
                  className=''
                  value={uldTypes.find(opt => opt.value === formData.uld_type) || null}
                  onChange={(selected) => {
                    setFormData({
                      ...formData,
                      uld_type: selected ? selected.value : null,
                    });
                  }}
                  name="uld_type"
                />
              </Form.Group>
              <Form.Group controlId="dropdown" className='sl_status mb-2'>
                <Form.Label>Contour Activated <span>*</span></Form.Label>
                <Form.Check
                  label="Yes"
                  name="contour_activated"
                  type='radio'
                  id='Operation'
                  value={1}
                  checked={formData.contour_activated === 1}
                  onChange={handleChange}
                />
                <Form.Check
                  label="No"
                  name="contour_activated"
                  type='radio'
                  id='Reserve'
                  value={0}
                  checked={formData.contour_activated === 0}
                  onChange={handleChange}
                />
              </Form.Group>
              {formData.contour_activated === 0 &&
                <>
                  <Form.Group controlId="dropdown" className='mb-3'>
                    <Form.Label>Length in CM <span>*</span></Form.Label>
                    <Form.Control type="number"
                      name='length'
                      value={formData.length}
                      onChange={handleChange} />
                  </Form.Group>
                  <Form.Group controlId="dropdown" className='mb-3'>
                    <Form.Label>Width in CM <span>*</span></Form.Label>
                    <Form.Control type="number"
                      name='width'
                      value={formData.width}
                      onChange={handleChange} />
                  </Form.Group>
                  <Form.Group controlId="dropdown" className='mb-3'>
                    <Form.Label>Height in CM <span>*</span></Form.Label>
                    <Form.Control type="number"
                      name='height'
                      value={formData.height}
                      onChange={handleChange} />
                  </Form.Group>
                  <Form.Group controlId="dropdown" className='mb-3'>
                    <Form.Label>Pallet <span>*</span></Form.Label>
                    <Form.Control type="text"
                      name='type'
                      value={formData.type}
                      onChange={handleChange} />
                  </Form.Group>
                </>
              }
            </>
          }
          {modalPos.sec === 'C' &&
            <>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Contour <span>*</span></Form.Label>
                <Form.Control type="text"
                  name='contour'
                  value={formData.contour}
                  onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Length in CM <span>*</span></Form.Label>
                <Form.Control type="number"
                  name='length'
                  value={formData.length}
                  onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Width in CM <span>*</span></Form.Label>
                <Form.Control type="number"
                  name='width'
                  value={formData.width}
                  onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Height in CM <span>*</span></Form.Label>
                <Form.Control type="number"
                  name='height'
                  value={formData.height}
                  onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Pallet <span>*</span></Form.Label>
                <Form.Control type="text"
                  name='type'
                  value={formData.type}
                  onChange={handleChange} />
              </Form.Group>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={closeModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={modalSubmit}>
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>




      {/* <Modal show={modalUldType} centered onHide={AddUldTypeClose} className='addfrom' >
        <Modal.Header closeButton>
          <Modal.Title>Add ULD Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="dropdown" className='mb-3'>
            <Form.Label>ULD Type</Form.Label>
            <Select
              options={uldTypes}
              placeholder="ULD Type"
              className=''
              value={uldTypes.find(opt => opt.value === formData.uld_type) || null}
              onChange={(selected) => {
                setFormData({
                  ...formData,
                  uld_type: selected ? selected.value : null,
                });
              }}
              name="uld_type"
            />
          </Form.Group>
          <Form.Group controlId="dropdown" className='sl_status mb-2'>
            <Form.Label>Contour Activated <span>*</span></Form.Label>
            <Form.Check
              label="Yes"
              name="contour_activated"
              type='radio'
              id='Operation'
              value="1"
              checked={formData.contour_activated == '1'}
              onChange={handleChange}
            />
            <Form.Check
              label="No"
              name="contour_activated"
              type='radio'
              id='Reserve'
              value="0"
              checked={formData.contour_activated == '0'}
              onChange={handleChange}
            />
          </Form.Group>
          {formData.contour_activated == 0 &&
            <>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Length in CM <span>*</span></Form.Label>
                <Form.Control type="number"
                  name='length'
                  value={formData.length}
                  onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Width in CM <span>*</span></Form.Label>
                <Form.Control type="number"
                  name='width'
                  value={formData.width}
                  onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Height in CM <span>*</span></Form.Label>
                <Form.Control type="number"
                  name='height'
                  value={formData.height}
                  onChange={handleChange} />
              </Form.Group>
              <Form.Group controlId="dropdown" className='mb-3'>
                <Form.Label>Pallet <span>*</span></Form.Label>
                <Form.Control type="text"
                  name='type'
                  value={formData.type}
                  onChange={handleChange} />
              </Form.Group>
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={() => AddUldTypeClose()}>
              No
            </Button>
            <Button variant="primary" onClick={submitUldType}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={modalContour} centered onHide={addContourClose} className='addfrom' >
        <Modal.Header closeButton>
          <Modal.Title>Add Contour</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <Form.Group controlId="dropdown" className='mb-3'>
              <Form.Label>Contour <span>*</span></Form.Label>
              <Form.Control type="text"
                name='contour'
                value={formData.contour}
                onChange={handleContourChange} />
            </Form.Group>
            <Form.Group controlId="dropdown" className='mb-3'>
              <Form.Label>Length in CM <span>*</span></Form.Label>
              <Form.Control type="number"
                name='length'
                value={formData.length}
                onChange={handleContourChange} />
            </Form.Group>
            <Form.Group controlId="dropdown" className='mb-3'>
              <Form.Label>Width in CM <span>*</span></Form.Label>
              <Form.Control type="number"
                name='width'
                value={formData.width}
                onChange={handleContourChange} />
            </Form.Group>
            <Form.Group controlId="dropdown" className='mb-3'>
              <Form.Label>Height in CM <span>*</span></Form.Label>
              <Form.Control type="number"
                name='height'
                value={formData.height}
                onChange={handleContourChange} />
            </Form.Group>
            <Form.Group controlId="dropdown" className='mb-3'>
              <Form.Label>Pallet <span>*</span></Form.Label>
              <Form.Control type="text"
                name='type'
                value={formData.type}
                onChange={handleContourChange} />
            </Form.Group>
          </>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="secondary" onClick={addContourClose}>
              No
            </Button>
            <Button variant="primary" onClick={submitContour}>
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal> */}
    </>
  )
}

export default UldSettings;